import { AsyncState, loadingAsyncState } from "widgets-for-react";
import { ContentGridItem } from "../content_grid_block";
import { TeaserProps } from "../teaser";
import { fetchRecentNews } from "./recentNewsBlockApi";

export interface RecentNewsBlockProps {
  title?: string
  count: number
  linkTitle?: string
  linkUrl?: string
  key?: string
}

export interface RecentNewsBlockState {
  items: AsyncState<TeaserProps[]>
}

export const initialState: (props: RecentNewsBlockProps) => RecentNewsBlockState = (props) => ({
  items: loadingAsyncState(fetchRecentNews(props.count))
})

export type RecentNewsBlockLayoutProps = RecentNewsBlockProps & RecentNewsBlockState